import DailyComponent from 'components/marketingSite/daily/DailyComponent';
import HeadMetadata from 'components/shared/HeadMetadata';
import { useI18n } from 'hooks/useI18n';
import { usePageTrack } from 'hooks/usePageTrack';
import { WithBaseUrl } from 'interfaces/ui/with-base-url';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Script from 'next/script';
import { APP_URLS } from 'utils/app-urls';
import { config } from 'utils/config';
import { getPublicPath } from 'utils/paths';

type DailyPageProps = WithBaseUrl;

const DailyPage: React.FC<DailyPageProps> = ({ baseUrl }) => {
  const { t } = useI18n('web');

  usePageTrack('Landing - Page Loaded');

  return (
    <>
      <HeadMetadata
        title={t('manfred-daily.page_title')}
        desc={t('manfred-daily.page_description')}
        url={APP_URLS.manfredDaily}
        imgUrl={`${baseUrl}${getPublicPath(
          '/images/cards/card_manfreddaily.png'
        )}`}
        indexable={true}
      />
      <Script
        id="manfred-daily"
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: `{
  "@context": "https://schema.org/",
  "@type": "Service",
  "name": "${t('manfred-daily.title')}",
  "provider": {
    "@type": "Organization",
    "name": "Manfred",
    "url": "https://www.getmanfred.com",
    "logo": "https://media-asgard.s3.eu-west-1.amazonaws.com/manfred-media/logo_manfred_color.svg?v=38732000"
  },
  "description": "${t('manfred-daily.description')}",
  "serviceType": "Newsletter de Oportunidades de Empleo IT",
  "areaServed": {
    "@type": "Country",
    "name": "España"
  },
  "offers": {
    "@type": "Offer",
    "price": "0",
    "priceCurrency": "EUR",
    "category": "Empleo IT",
    "availability": "https://schema.org/InStock"
  }
}`
        }}
      />
      <DailyComponent />
    </>
  );
};

export default DailyPage;

export const getStaticProps: GetStaticProps<DailyPageProps> = async ({
  locale
}) => {
  return {
    props: {
      ...(await serverSideTranslations(locale || '', [
        'common',
        'topbar',
        'footer',
        'web'
      ])),
      baseUrl: config.appUrl
    },
    revalidate: 30
  };
};
